module.exports = __webpack_public_path__ + "static/media/DUCSA.20a49b4a.jpg";